export enum PortalRegion {
  Global = 'global',
  China = 'china'
}

/** The region is defined by the domain the portal is served from. */
export const detectPortalRegion = (hostname: string = window.location.hostname): PortalRegion =>
  hostname.endsWith('.cn') ? PortalRegion.China : PortalRegion.Global;
